export default {
  getterUserContext: state => state.context
};
